import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", y = 24 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
    <p className={`flex items-center gap-3 font-mono text-[11px] font-medium uppercase tracking-[0.22em] ${light ? "text-slate-400" : "text-brand-red"}`}>
        <span className={`inline-block h-px w-8 ${light ? "bg-slate-600" : "bg-brand-red"}`} />
        {children}
    </p>
);

export default FadeUp;
